<div class="data-card-body position-relative">
  <!-- Loader -->
  <nz-spin nzTip="Loading..." [nzSpinning]="isLoading.mo"></nz-spin>

  <!-- Main Object -->
  @if (mo && !isLoading.mo) {
    <!-- Display Data -->
    @if (moData) {
      @if (moType === 'VLV') {
        <app-data-valve
          (openSDLEvent)="onOpenNewMO($event)"
          [hasCMMSPackage]="hasCMMSPackage()"
          [hasRCAFPackage]="hasRCAFPackage()"
          [data]="moDataFE"
          [filter]="filter"
          [ttmURLParams]="getTravelTimeMonitoringURLParams(mo)"></app-data-valve>
      }

      @if (moType === 'BRK') {
        <app-data-breaker
          (openSDLEvent)="onOpenNewMO($event)"
          [hasCMMSPackage]="hasCMMSPackage()"
          [hasRCAFPackage]="hasRCAFPackage()"
          [data]="moDataFE"
          [filter]="filter"
          [ttmURLParams]="getTravelTimeMonitoringURLParams(mo)"></app-data-breaker>
      }

      @if (moType === 'FD_FE_MOT_NFS') {
        <app-data-fd
          (openSDLEvent)="onOpenNewMO($event)"
          [hasCMMSPackage]="hasCMMSPackage()"
          [hasRCAFPackage]="hasRCAFPackage()"
          [data]="moDataFE"
          [filter]="filter"
          [ttmURLParams]="getTravelTimeMonitoringURLParams(mo)"></app-data-fd>
      }

      @if (moType === 'PT') {
        <app-data-process-transmitters
          (openSDLEvent)="onOpenNewMO($event)"
          [hasCMMSPackage]="hasCMMSPackage()"
          [hasRCAFPackage]="hasRCAFPackage()"
          [data]="moDataPT"
          [filter]="filter"></app-data-process-transmitters>
      }

      @if (moType === 'BPI') {
        <app-data-binary-process-ini
          (openSDLEvent)="onOpenNewMO($event)"
          [hasCMMSPackage]="hasCMMSPackage()"
          [hasRCAFPackage]="hasRCAFPackage()"
          [data]="moDataBPI"
          [filter]="filter"></app-data-binary-process-ini>
      }

      @if (moType === 'FGD') {
        <app-data-flame-gas
          [hasCMMSPackage]="hasCMMSPackage()"
          [hasRCAFPackage]="hasRCAFPackage()"
          [data]="moDataFGD"
          [filter]="filter"></app-data-flame-gas>
      }

      @if (moType === 'BFGI') {
        <app-data-binary-fg-ini
          [hasCMMSPackage]="hasCMMSPackage()"
          [hasRCAFPackage]="hasRCAFPackage()"
          [data]="moDataBFGI"
          [filter]="filter"></app-data-binary-fg-ini>
      }

      @if (moType === 'SDL') {
        <app-data-sdl
          [hasCMMSPackage]="hasCMMSPackage()"
          [data]="moDataSDL"
          [filter]="filter"></app-data-sdl>
      }
    } @else {
      <nz-alert nzType="info" nzMessage="No data available!" nzCloseable="true" nzShowIcon="true"></nz-alert>
    }

    <!-- Data Card FORM -->
    @if (displayMainForm() || displayDeviationURLForm()) {
      <app-form-main
        [disabledMainFormControls]="!canSaveDataCard()"
        [displayMainForm]="displayMainForm()"
        [displayUrlForm]="displayDeviationURLForm()"
        [mainFormData]="moDataFE"
        [urlFormData]="deviationURLData"
        [dataCardType]=moType
        [mainObject]="mo"
        (notifyDataCard)="onNotifyDataCardMainForm($event)"
        (notifyUrlDataCard)="onNotifyDataCardDevUrl($event)"></app-form-main>
    }
  }
</div>

